import axios from 'axios';
import router from '@/router';
import { getCsrfToken } from '@/services/csrf';
import { convertKeys, toCamelCase, toSnakeCase } from '@/shared/functions/caseConverte';
import authService from './services/authService';
import { clean_logout } from './shared/functions/logout';




const pathRefresh = `/TokenRefreshView/`;

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/vnd.api+json',
    Accept: '*/*'
  }
});

//Request interceptor - converte camelCase para snake_case
api.interceptors.request.use((config) => {
  try {
    if (config.data) {
      // console.log("interceptors.request.data", config)
      config.data = convertKeys(config.data, toSnakeCase);
    }
    if (config.params) {
      // console.log("interceptors.request.params", config)
      config.params = convertKeys(config.params, toSnakeCase);
    }
    return config;
  } catch (error) {
    console.error('Error', error);
  }
});

// Response interceptor - converte snake_case para camelCase
api.interceptors.response.use((response) => {
  try {
    // Ignora conversão para respostas blob (downloads de arquivos)
    if (response?.config?.responseType === 'blob') {
      return response;
    }
    if (response?.data) {
      // console.log("interceptors.response", response)
      response.data = convertKeys(response.data, toCamelCase);
    }
    return response;

  } catch (error) {
    console.error('Error', error);

  }
});

api.interceptors.request.use((config) => {
  try {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      config.headers['X-CSRFToken'] = csrfToken;
    }
    return config;

  } catch (error) {
    console.error('Error', error);

  }
});

export const refreshToken = async () => {
  try {
    const tokenRefresh = localStorage.getItem('tokenRefresh');
    const response = await api.post(pathRefresh, {
      tokenRefresh
    });
    const { access, refresh } = response?.data;
    localStorage.setItem('tokenAccess', access);
    localStorage.setItem('tokenRefresh', refresh);
    return access;
  } catch (error) {
    clean_logout()
    throw new Error('Token refresh failed');
  }
};

let refreshTokenTimeout;

const resetRefreshTokenTimer = () => {
  if (refreshTokenTimeout) clearTimeout(refreshTokenTimeout);

  refreshTokenTimeout = setTimeout(
    async () => {
      try {
        const refreshToken = localStorage.getItem('refreshToken');
        const response = await api.post('/TokenRefreshView/', {
          refresh: refreshToken
        });

        const { access, refresh } = response?.data;
        localStorage.setItem('tokenAccess', access);
        localStorage.setItem('tokenRefresh', refresh);
      } catch (error) {
        router.push({ name: 'login' });
      }
    },
    55 * 60 * 1000
  ); // 55 minutes
};
api.interceptors.request.use(
  (config) => {
    const tokenAccess = localStorage.getItem('tokenAccess');
    if (tokenAccess) {
      config.headers.Authorization = `Bearer ${tokenAccess}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    resetRefreshTokenTimer();
    return response;
  },
  async (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      clean_logout()
      router.push({ name: 'login' });
    }
    return Promise.reject(error);
  }
);

export default api;
